import React from 'react';
import ColataShell from '../../components/colata/ColataShell';
import TabellaInterventi from './components/TabellaInterventi';

// /colata-interventi — sostituzioni, rientri e ordini
const ColataInterventiPage = () => (
  <ColataShell indietroA="/colata-inventory">
    <TabellaInterventi />
  </ColataShell>
);

export default ColataInterventiPage;
